import React from 'react'
import {API_BASE_URL} from '../../constants'
import axios from 'axios'
import ReactTable  from "react-table";
import {getToken, getDateRange} from '../../storage'
import {DRN} from '../report/daterange'
import moment from 'moment'
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import {updateHistory} from '../commons/functions'
import SearchInput from '../search/search'

export default class ExpenseList extends React.Component {


  constructor(props) {
    super(props);
    this.state = {
      data: [],
      dateRange : getDateRange(),
      pages: null,
      expense_category: props.location.state ? (props.location.state.expense_category || null): null,
      expense_search: props.location.state ? (props.location.state.expense_search || null): null,
      loading: true
    };
    this.handleTrclick = this.handleTrclick.bind(this)
    this.goToCreateExpense = this.goToCreateExpense.bind(this)
    document.title = "Expense List"
  }

  goToCreateExpense(e) {
    e.preventDefault()
    this.props.history.push("/expenses/create/")
  }

  handleTrclick(state,row, column, instance) {
    return {
      onClick : (e, handleOriginal)=>{
        this.props.history.push('/expenses/edit/'+row.original.id)
      },
      style: {
        cursor:'pointer'
      }
    }
  }

  getExpenseCategories = (input)=> {

    if(!input) {
      return Promise.resolve({ options: [] });
    }

    return   axios({
        url: '/get_expense_categories/?q='+input,
        method: 'get',
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then((response)=> {
            return {options: response.data.expense_categories}
      }).catch((err)=> {
        return Promise.resolve({ options: [] });
      })
  }

  handleExpenseCategoryChange=(value)=> {
    this.setState({expense_category: value})
    this.fetchData(this.state.tableState, {}, value)
    updateHistory(this.props, {expense_category:value})
  }

  applyDateRange = (dateRange) => {
    this.fetchData(this.state.tableState, {}, this.state.expense_category, dateRange)
  }

  handleSearchExpense = (q) => {
    this.fetchData(this.state.tableState, {}, this.state.expense_category, this.state.dateRange, q)
    updateHistory(this.props, {expense_search:q})
  }

    fetchData =(state, instance, expense_category=this.state.expense_category, dateRange=this.state.dateRange, expense_search=this.state.expense_search)=> {
      this.setState({ loading: true });
      let apiurl = "/list_expenses/?page=" + state.page + '&page_size='+state.pageSize;
      if(typeof state.sorted !== "undefined" && state.sorted.length > 0) {
          apiurl = apiurl + '&sort_column='+state.sorted[0]['id']
          apiurl = apiurl + '&sort_dir='+state.sorted[0]['desc']
      }
      if(typeof expense_category !== "undefined" && expense_category !== null) {

        apiurl = apiurl + '&expense_category='+expense_category.value
      }
      if(expense_search) {
        apiurl = apiurl + "&expense_search="+expense_search
      }
      if(dateRange) {
        let startdate = typeof dateRange.startDate === "string" ? new Date(dateRange.startDate): dateRange.startDate;
        let enddate = typeof dateRange.endDate === "string" ? new Date(dateRange.endDate): dateRange.endDate;
        let start_date = startdate.getFullYear()+"-"+ (startdate.getMonth()+1)+"-"+startdate.getDate()
        let end_date = enddate.getFullYear()+"-"+ (enddate.getMonth()+1)+"-"+enddate.getDate()
        apiurl = apiurl + "&start_date="+start_date+"&end_date="+end_date
      }
      this.setState({tableState:state, expense_category:expense_category, dateRange:dateRange, expense_search:expense_search})

      axios({
        url: apiurl,
        baseURL: API_BASE_URL,
        headers: {
          common: {
            'Authorization': 'Token ' + getToken()
          }
        }
      }).then(res => {
        this.setState({
          data: res.data.expenses,
          pages: res.data.pages,
          loading: false
        });
      });
    }


    render() {

      const { data, pages, loading } = this.state;
      const columns = [
        {Header:'Date',  accessor:'date',sortable:true,  Cell:(row)=>{return moment(row.original.date).format('DD-MM-YYYY')}},
        {Header:'Name', accessor: 'name',sortable:true },
        {Header:'Category', accessor: 'category',sortable:true },
        {Header:'Notes', accessor: 'notes',sortable:true },
        {Header:'Amount',  accessor:'amount',sortable:true, Cell:(row)=>(<div className="text-right">{row.original.amount}</div>)},

      ]
      const defaultSort=[{id: "date", desc: true}]

      return <div><section className="medium">

      <div className="row">
        <div className="col-sm-2">
            <button onClick={this.goToCreateExpense} className="btn btn-primary">Create New Expense</button>
        </div>

        <div className="col-sm-7">

        <div className="col-sm-4">
          <SearchInput value={this.state.expense_search} handleSearchInput={this.handleSearchExpense} placeholder={"Search Expenses"} />
        </div>

        <div className="col-sm-4">
          <Select.Async multi={false} onChange={this.handleExpenseCategoryChange}
          value={this.state.expense_category} valueKey="value" labelKey="name"

          loadOptions={this.getExpenseCategories} backspaceRemoves={true} placeholder="Select Category"/>
        </div>

        </div>

        <div className="col-sm-3">
            <DRN applyDateRange={this.applyDateRange} dateRange={this.state.dateRange} />
        </div>

      </div>


      </section>
      <div className="row">
        <div className="col-sm-12">
          <div className="table-responsive">
            <ReactTable defaultSorted={defaultSort}
              getTrProps={this.handleTrclick}
              noDataText="No Expenses Found."
                columns={columns} manual data={data}
                pages={pages} loading={loading} onFetchData={this.fetchData} minRows={5} defaultPageSize={20} />
          </div>

        </div>
      </div>

      </div>
    }
}



// WEBPACK FOOTER //
// ./src/components/expense/expenselist.js